module.exports = __webpack_public_path__ + "img/frame (153).3777bc3b.jpg";